module.exports = __webpack_public_path__ + "img/vacunas5.e195f9f8.jpg";